export default __webpack_public_path__ + "static/Plots0002-e73bc1c69544fab7c72d4a13c08038a0.jpg";